import { FormInstance } from 'antd';
import cashierService from 'modules/POS/services';
import cashierApis from 'modules/POS/services/apis';
import { IApiUpdateTicketBody } from 'modules/POS/services/types/ticket';
import { useRef } from 'react';
import { useAppDispatch } from 'store/hooks';
import { mappingSavePayload } from '../cashier.utils';
import ModalCashierAutoSave, { useModalCashierAutoSaveRef } from '../features/ModalAutoSave';

const useAutoSaveGuard = (form: FormInstance<any>): [{
  call: (_callback: () => void) => void;
  isDone: () => boolean;
  reset: () => void;
}, JSX.Element] => {
  const modalConfirmSaveRef = useModalCashierAutoSaveRef();
  const callbackRef = useRef<() => void>(() => undefined);
  const isValid = useRef<boolean>(false);
  const dispatch = useAppDispatch();
  const onCancel = () => callbackRef.current();
  const context = <ModalCashierAutoSave ref={modalConfirmSaveRef} onOk={() => form.submit()} onCancel={onCancel} />;

  const autoSaveTicket = async (_callback: () => void) => {
    _callback();
    try {
      const body: IApiUpdateTicketBody = mappingSavePayload(form.getFieldsValue());
      if (!body.items?.length) return;
      const res = await cashierApis.updateTicket(body);
      if (res.data.data) {
        dispatch(cashierService.actions.async.lstBillOnHold.fetch());
      }
    } catch (error) {
    }
  };

  const handleReset = () => {
    isValid.current = false;
    callbackRef.current = () => undefined;
  };

  const handleDone = () => {
    if (isValid.current) {
      callbackRef.current();
      return true;
    }
    return false;
  };

  return ([
    {
      call: autoSaveTicket,
      isDone: handleDone,
      reset: handleReset,
    },
    context,
  ]);
};

export default useAutoSaveGuard;
